import { fromJS, Map } from 'immutable';
import actionTypes from '../../actions/actionTypes';
import requestStatus from '../../constants/requestStatus';

const INIT_STATE = fromJS({
    status: requestStatus.INITIALIZED,
    error: null,
    session: {
        expired: false,
        state: false,
        userName: false,
        aliveUntil: false,
        bypass: false
    },
    caps: {
        programDataFetch: false,
        programDataGet: false,
        programDataUpdate: false,
        programDataSee: false,
        cinemaDataSee: false,
        printDataGet: false,
        printDataUpdate: false,
        pushDataGet: false,
        pushDataUpdate: false,        
        pushDataCreate: false,        
        routesDataGet: false,
		routesDataUpdate: false,
        cliDataGet: false,
        wpDataGet: false,
        wpDataUpdate: false,
        newsletterDataGet: false,
        newsletterDataUpdate: false,
        newsletterDataSend: false,
        multisiteSelectorDataGet: false,
        multisiteSelectorDataUpdate: false,
        signageDataGet: false,
        wpPagesGet: false,
        wpServicePagesGet: false,
        wpMenuItemsGet: false,
        eventDataGet: false,
        eventDataUpdate: false,
        eventDataDelete: false
    }
});

const onRequest = (state, action)   => state.set('status', requestStatus.REQUEST_PENDING)
                                            .set('error', '')
                                            .set('session', INIT_STATE.get('session'))
                                            .set('caps', INIT_STATE.get('caps'))

const onError = (state, action)     => state.set('status', requestStatus.REQUEST_ERROR)
                                            .set('error', action.payload.errorMessage)
                                            .setIn(['session', 'expired'], false)
                                            .set('caps', INIT_STATE.get('caps'))

const onSuccess = (state, action)   => state.set('status', requestStatus.REQUEST_SUCCESS)

const onSetCupsData = (state, action) => {
    let newState = state.set('caps', INIT_STATE.get('caps'))

    const userCaps = action.payload.caps

    Object.keys(userCaps).forEach(key => {
        newState = newState.setIn(['caps', key] , !!userCaps[key])
    })

    return newState
}

const onSetSessionData = (state, action) => {
    return state.set('session', Map({
        expired: action.payload.expired,
        state: action.payload.state,
        userName: action.payload.userName,
        aliveUntil: action.payload.aliveUntil,
        bypass: action.payload.bypass
    }))
}

const onSetSessionDataAlive = (state, action) => {
    return state.setIn(['session', 'aliveUntil'], action.payload.aliveUntil)
}

const onClearData = () => {
    return INIT_STATE.set('error', '')
}


const authReducer = (state = INIT_STATE, action) => {
    switch(action.type){
        case actionTypes.AUTH_FLOW_LOGIN_REQUEST_SESSION:
        case actionTypes.AUTH_FLOW_LOGIN_REQUEST_FORCE_SESSION:
        case actionTypes.AUTH_FLOW_LOGIN_REQUEST_BYPASS:
        case actionTypes.AUTH_FLOW_LOGIN_REQUEST_FORCE_BYPASS:
        case actionTypes.AUTH_FLOW_LOGOUT_REQUEST_CLIENT:
        case actionTypes.AUTH_FLOW_LOGOUT_REQUEST_WP:
            return onRequest(state, action);
        case actionTypes.AUTH_FLOW_SUCCESS:
            return onSuccess(state, action);
        case actionTypes.AUTH_FLOW_ERROR:
            return onError(state, action)
        case actionTypes.AUTH_SET_SESSION_DATA:
            return onSetSessionData(state, action)
        case actionTypes.AUTH_SET_SESSION_DATA_ALIVE:
            return onSetSessionDataAlive(state, action)
        case actionTypes.AUTH_SET_CAPS_DATA:
            return onSetCupsData(state, action)
        case actionTypes.AUTH_CLEAR_DATA:
            return onClearData()
        default:
            return state
    }
}

export default authReducer